// extracted by mini-css-extract-plugin
export var label = "_ea-2";
export var slideContainer = "_ea-0";
export var slider = "_ea-1";